export default () => {

    document.addEventListener("click", someClick, false);

    function someClick(event) {
        // console.log(event);
    }

    // const Player = document.getElementById('player2');
    // const PlayBtn = document.getElementById('play');
    // const poster = document.getElementById('poster');
    // //const stopBtn = document.getElementById('stop');
    // let times = 0, playY;
    //
    // const playVideo = PlayBtn.addEventListener('click', () => {
    //     if (times === 0) {
    //         PlayBtn.style.display = "none";
    //         poster.style.display = "none";
    //         playY = Player.src += '?autoplay=1';
    //         times = 1;
    //     }
    // });
    //
    // // stopBtn.addEventListener('click', () => {
    // //     playY = playY.slice(0, -11);
    // //     Player.src = playY
    // //     times = 0;
    // // });

}